import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";

const saveFormRecord = async (sessionID, form) => {
    const path = `IT/forms/cancelation-form/${sessionID}/formRecords`;
    const docRef = collection(db, path);
    await addDoc(docRef, {
      ...form,
      timestamp: Date.now(),
    });
  };

export default saveFormRecord;
